module.exports = __webpack_public_path__ + "static/img/service_right.e34602f2.png";